import { toLocaleString } from '@/lib/currency-helpers';
import { useLocale } from '@/lib/hooks/use-locale';
import React from 'react';
import SmallSpinner from '../ui/small-spinner';

type Props = {
    isLoadingCount: boolean;
    count?: number;
    children?: React.ReactNode | React.ReactNode[] | string;
};

export const TableHeader: React.FC<Props> = ({ isLoadingCount, count, children }) => {
    const { t, locale } = useLocale();

    return (
        <div className="mb-2.5 flex w-full flex-row items-center justify-between">
            <div className="flex grow">{children}</div>
            <div className="font-base text-sm flex  text-right leading-3">
                {!Number.isNaN(count) && !isLoadingCount ? (
                    <span className="mr-1">{toLocaleString(Number(count), locale)}</span>
                ) : (
                    <div className="mr-1 flex items-center justify-center">
                        <SmallSpinner />
                    </div>
                )}
                {count === 1 ? t('table_count_results_singular') : t('table_count_results_plural')}
            </div>
        </div>
    );
};
